export default "/_next/static/images/6d16cd44c67492575f5c151fb9b0370f.png";